<template>
  <div :style="'min-width: 160px; background-color:' + bgColor + '; height:' + height">
    <div style="display: flex">
      <slot name="title">
        <p class="h6" v-if="!!title" :style="'color:' + titleColor + '!important; font-size: 16px;'">
          <strong> {{ title }}</strong>
        </p>
      </slot>
      <v-spacer v-if="!!titleEnd" />
    </div>
    <slot>
      <div style="border-left: 4px solid black;">
      <div v-if="!loading && !!value" :style="'color:' + valueColor + '!important; bottom: 0rem; padding: 10px'
        ">
        {{ value }}
      </div>
    </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "RoundedBox",
  props: {
    title: {
      type: String,
      default: "",
    },
    titleEnd: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "#ffffffcc",
    },
    titleColor: {
      type: String,
      default: "#000",
    },
    valueColor: {
      type: String,
      default: "#000",
    },
    height: {
      type: String,
      default: "auto",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>